import React, { memo } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useStyles } from './styles';

interface ILoaderProps {
  styleClass?: string;
}

const Loader = ({ styleClass }: ILoaderProps) => {
  const classes = useStyles();
  return (
    // <Backdrop
    //   // sx={{ color: STYLE.COLOR.WHITE, zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
    //   style={{ color: STYLE.COLOR.WHITE, zIndex: 1501 }}
    //   open={true}
    //   // onClick={}
    // >
    <CircularProgress className={`${classes.spinner} ${styleClass}`} />
    // </Backdrop>
  );
};

export default memo(Loader);
